<template>
  <div class="form-group" :class="{'input-box': showInputBox}">
    <i
      v-if="addEmailNotification"
      class="glyphicon glyphicon-envelope"
      v-tooltip="'Email might be generated'"
      title="Email might be generated"
    >
    </i>

    <span class="form-group">
      <label :class="{ 'text-danger': hasErrors(getFieldName) }"> {{ label }} </label>
      <comments v-if="addComment" :field-name="getCommentfieldName" :model-name="modelName"></comments>
    </span>

    <div class="form-check" v-for="(option, index) in options" :value="option.value" :key="index">
      <label class="form-check-label" :for="`${getFieldName}-${option.value}`" :class="{ 'text-danger': hasErrors(getFieldName) }">
        <input
          class="form-check-input"
          type="checkbox"
          :id="`${getFieldName}-${option.value}`"
          :checked="inputVal.includes(option.value)"
          @change="updateVal(option, $event)"
          :name="option.display"
          :disabled="isReadOnly || disabled"
        />

        {{ option.display }}
      </label>
    </div>

    <span v-show="errors.has(getFieldName)" class="text-danger">{{ errors.first(getFieldName) }}</span>

    <div v-show="hasErrors(getFieldName)">
      <span
        v-for="(error, index) in errorsFor(getFieldName)"
        class="text-danger"
        :key="`error_${getFieldName}_${index}`"
      >
        {{ error }}
      </span>
    </div>
  </div>
</template>

<script>
import CustomInputMixin from './CustomInputMixin'

export default {
  name: 'SelectCheckBoxInput',
  mixins: [CustomInputMixin],
  props: {
    options: Array,
  },
  computed: {
    inputVal: {
      get() {
        let value = this.getFieldValue(this.getFieldName, this.modelName) || []
        return value
      },
      set(val) {
        let payload = {
          fieldName: this.getFieldName,
          value: val,
          modelName: this.modelName,
        }

        this.setFieldValue(payload)
        this.$emit('on-change', payload)
      },
    },
  },
  methods: {
    updateVal(option, event) {
      let subscriptionGroups = this.inputVal
      if (event.target.checked) {
        subscriptionGroups.push(option.value)
      } else {
        subscriptionGroups = subscriptionGroups.filter((sb) => sb != option.value)
      }
      let payload = {
        fieldName: this.getFieldName,
        value: subscriptionGroups,
        modelName: this.modelName,
      }

      this.setFieldValue(payload)

      this.$emit('on-change', payload)
    },
  },
}
</script>

<style scoped>
i {
  margin-right: 0.5em;
}
</style>
